export const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
} as const
